import { createContext } from 'react';
import { IDishes, TDishesSelectedItem } from 'types';

export type TDishesSortBy = '' | 'NameA-Z' | 'NameZ-A' | 'Price1-10' | 'Price10-1';
export type TCountOfDishes = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error' | 'copyMenuModal';
export type TFullDishInfoVisibleForm = 'mainForm' | 'additionally' | 'translations';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: TDishesSelectedItem;
	IDSelectedRestaurant: TDishesSelectedItem;
	IDSelectedCategory: TDishesSelectedItem;
	IDSelectedSubCategory: TDishesSelectedItem;
	priceFrom: string;
	priceTo: string;
	sortBy: TDishesSortBy;
	countOfItems: TCountOfDishes;
	currentPage: number;
	isUnassignedDishes: boolean;
	isDisabledDish: boolean;
	isShowOnlyComboItems: boolean;
}

export interface IDishesState {
	dishes: IDishes;
	searchString: string;
	IDSelectedCustomer: TDishesSelectedItem;
	IDSelectedRestaurant: TDishesSelectedItem;
	IDSelectedCategory: TDishesSelectedItem;
	IDSelectedSubCategory: TDishesSelectedItem;
	priceFrom: string;
	priceTo: string;
	sortBy: TDishesSortBy;
	countOfItems: TCountOfDishes;
	currentPage: number;
	isUnassignedDishes: boolean;
	isDisabledDish: boolean;
	isShowOnlyComboItems: boolean;
	dishIDForDeletion: string;
	dishIDForFullInfo: string;
	typeOfModalWindow: TTypeOfModalWindow;
	fullDishInfoVisibleForm: TFullDishInfoVisibleForm;
}

export const dishesInitialState: IDishesState = {
	dishes: { dishesCount: 0, dishes: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedCategory: null,
	IDSelectedSubCategory: null,
	priceFrom: '',
	priceTo: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	isUnassignedDishes: false,
	isDisabledDish: false,
	isShowOnlyComboItems: false,
	dishIDForDeletion: '',
	dishIDForFullInfo: '',
	typeOfModalWindow: null,
	fullDishInfoVisibleForm: 'mainForm',
};

export interface IDishesContext extends IDishesState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDCustomer(value: TDishesSelectedItem): void;
	setIDRestaurant(value: TDishesSelectedItem): void;
	setIDCategory(value: TDishesSelectedItem): void;
	setIDSubCategory(value: TDishesSelectedItem): void;
	setPriceFrom(value: TDishesSelectedItem): void;
	setPriceTo(value: TDishesSelectedItem): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TDishesSortBy): void;
	toggleUnassignedDishes(): void;
	toggleDisabledDishes(): void;
	toggleShowComboItems(): void;
	setCountOfItems(count: TCountOfDishes): void;
	changeCurrentPage(page: number): void;
	setDishIDForDeletion(dishID: string): void;
	setDishIDForFullInfo(dishID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeFullDishInfoVisibleForm(value: TFullDishInfoVisibleForm): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const DishesContext = createContext<IDishesContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDCategory: () => undefined,
	setIDSubCategory: () => undefined,
	setPriceFrom: () => undefined,
	setPriceTo: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	toggleUnassignedDishes: () => undefined,
	toggleDisabledDishes: () => undefined,
	toggleShowComboItems: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setDishIDForDeletion: () => undefined,
	setDishIDForFullInfo: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeFullDishInfoVisibleForm: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...dishesInitialState,
});
